export default (props, keys) => Object.keys(props)
  .filter(key => !keys.includes(key))
  .reduce((obj, key) => ({...obj, [key]: props[key]}), {});



// WEBPACK FOOTER //
// ./src/utilities/filterKeys.js